const CANCEL = 'Cancel';
const HELP = 'Help';
const BACK_SPACE = 'Backspace';
const TAB = 'Tab';
const CLEAR = 'Clear';
const ENTER = 'Enter';
const SHIFT = 'Shift';
const CONTROL = 'Control';
const ALT = 'Alt';
const PAUSE = 'Pause';
const CAPS_LOCK = 'CapsLock';
const ESCAPE = 'Escape';
const SPACE = ' ';
const PAGE_UP = 'PageUp';
const PAGE_DOWN = 'PageDown';
const END = 'End';
const HOME = 'Home';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_UP = 'ArrowUp';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_DOWN = 'ArrowDown';
const INSERT = 'Insert';
const DELETE = 'Delete';
const CONTEXT_MENU = 'ContextMenu';
const META = 'Meta';
export const KEYNAME = {
    CANCEL,
    HELP,
    BACK_SPACE,
    TAB,
    CLEAR,
    ENTER,
    SHIFT,
    CONTROL,
    ALT,
    PAUSE,
    CAPS_LOCK,
    ESCAPE,
    SPACE,
    PAGE_UP,
    PAGE_DOWN,
    END,
    HOME,
    ARROW_LEFT,
    ARROW_UP,
    ARROW_RIGHT,
    ARROW_DOWN,
    INSERT,
    DELETE,
    CONTEXT_MENU,
    META,
};
